/**
 * Aufgabenstatus
 * @class constant_v3sExerciseStatus
 * @memberOf v3sWbtPlayerApp:exercise
 * @param NO_ANSWER - keine Lösung, Aufgabe wurde nicht bearbeitet
 * @param CORRECT - korrekte Lösung, Aufgabe wurde korrekt bearbeitet
 * @param FALSE - falsche Lösung, Aufgabe wurde falsch bearbeitet
 * @param CORRECT_AND_FALSE - korrekte und falsche Lösung, Aufgabe beinhaltet korrekte und flasche Antworten
 * @param ALL_CORRECT_AND_FALSE - korrekte und falsche Lösung, Aufgabe beinhaltet alle korrekte und einige flasche Antworten
 * @param CORRECT_NOT_ALL - nicht vollständig korrekte Lösung, Aufgabe beinhaltet nicht alle korrekte und keine flasche Antworten
 */
angular.module('v3sWbtPlayerApp').constant('v3sExerciseStatus', {
    NO_ANSWER: { value: 0, message: 'no_answer' },
    CORRECT: { value: 1, message: 'correct' },
    FALSE: { value: 2, message: 'false' },
    CORRECT_AND_FALSE: { value: 3, message: 'correct_and_false' },
    ALL_CORRECT_AND_FALSE: { value: 4, message: 'all_correct_and_false' },
    CORRECT_NOT_ALL: { value: 5, message: 'correct_not_all' }
});

/**
 * Die Stati, die ein Aufgabenelement haben kann
 * @class constant_v3sExerciseElementStatus
 * @memberOf v3sWbtPlayerApp:exercise
 * @param NO_ANSWER - keine Antwort, Aufgabenelement wurde nicht bearbeitet
 * @param CORRECT - korrekte Antwort, Aufgabenelement wurde korrekt bearbeitet
 * @param SILENT_CORRECT - korrekte Antwort, Aufgabenelement ist ohne Bearbeitung korrekt
 * @param FALSE - falsche Antwort, Aufgabenelement wurde falsch bearbeitet
 * @param FALSE_ABOVE - falsche Antwort, Antwort ist größer als die Lösung
 * @param FALSE_BELOW - falsche Antwort, Antwort ist kleiner als die Lösung
 */
angular.module('v3sWbtPlayerApp').constant('v3sExerciseElementStatus', {
    NO_ANSWER: { value: 0, name: 'no_answer', correct: false, incorrect: false},
    CORRECT: { value: 1, name: 'correct', correct: true, incorrect: false },
    SILENT_CORRECT: { value: 2, name: 'silent_correct', correct: true, incorrect: false },
    FALSE: { value: 3, name: 'false', correct: false, incorrect: true },
    FALSE_ABOVE: { value: 4, name: 'false_above', correct: false, incorrect: true },
    FALSE_BELOW: { value: 5, name: 'false_below', correct: false, incorrect: true }
});